export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            有料你就来，一起吃瓜一起嗨
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-primary-100 text-primary-600">
                  <i className="ri-mail-send-line text-xl"></i>
                </span>
                <div className="text-sm font-medium text-foreground-900 mb-1">邮箱投稿</div>
                <div className="text-xs text-foreground-500">tg@51chigua.app</div>
              </div>
              <div className="text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-wechat-line text-xl"></i>
                </span>
                <div className="text-sm font-medium text-foreground-900 mb-1">微信联系</div>
                <div className="text-xs text-foreground-500">51chigua_official</div>
              </div>
              <div className="text-center">
                <span className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-secondary-100 text-secondary-600">
                  <i className="ri-discuss-line text-xl"></i>
                </span>
                <div className="text-sm font-medium text-foreground-900 mb-1">站内私信</div>
                <div className="text-xs text-foreground-500">注册即可发送</div>
              </div>
            </div>
            <div className="bg-background-50 rounded-xl p-5 text-center">
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                如果你有台北娜娜、莫里秀、玩偶姐姐或其他热门人物的独家爆料，欢迎通过以上方式联系我们。
                所有投稿均严格保密，一经采用将给予丰厚奖励。
              </p>
              <button className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
                立即投稿
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}